import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const HERO_SRC =
  "https://images.unsplash.com/photo-1606788075819-9574a6edfab3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const Preloader = ({ onDone }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const start = Date.now();
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      const wait = Math.max(0, 1200 - (Date.now() - start));
      setTimeout(() => {
        setShow(false);
        onDone();
      }, wait);
    };
    const img = new Image();
    img.onload = finish;
    img.onerror = finish;
    img.src = HERO_SRC;
    const maxTimer = setTimeout(finish, 2600);
    return () => clearTimeout(maxTimer);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center"
          data-testid="intro-preloader"
        >
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="h-px w-24 bg-gold origin-left"
          />
          <div className="overflow-hidden mt-6">
            <motion.p
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-2xl sm:text-4xl tracking-[0.18em] text-cream text-center"
            >
              IRON GATE <span className="text-gold">CONSULTING</span>
            </motion.p>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.55 }}
            className="text-gold/80 text-[10px] sm:text-xs tracking-[0.34em] uppercase mt-5"
          >
            U.S. Veteran Owned and Operated
          </motion.p>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="h-px w-24 bg-gold origin-right mt-6"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
